export default () => (
  <>
    <option value=''>--</option>
    <option value='AIRPORT'>AIRPORT</option>
    <option value='AVE'>AVE</option>
    <option value='BLVD'>BLVD</option>
    <option value='CIR'>CIR</option>
    <option value='CIRCLE DR'>CIRCLE DR</option>
    <option value='CT'>CT</option>
    <option value='CRES'>CRES</option>
    <option value='DR'>DR</option>
    <option value='EXPY'>EXPY</option>
    <option value='RAMP'>RAMP</option>
    <option value='ER'>ER</option>
    <option value='XR'>XR</option>
    <option value='FLD'>FLD</option>
    <option value='HWY'>HWY</option>
    <option value='LN'>LN</option>
    <option value='MKT'>MKT</option>
    <option value='PKWY'>PKWY</option>
    <option value='PL'>PL</option>
    <option value='PLAISANCE'>PLAISANCE</option>
    <option value='PLZ'>PLZ</option>
    <option value='RL'>RL</option>
    <option value='RD'>RD</option>
    <option value='ROW'>ROW</option>
    <option value='SR'>SR</option>
    <option value='SKYWAY'>SKYWAY</option>
    <option value='SQ'>SQ</option>
    <option value='ST'>ST</option>
    <option value='TER'>TER</option>
    <option value='TOLL'>TOLL</option>
    <option value='WAY'>WAY</option>
  </>
);

export const StreetTypes = [
  { cd: '', descr: '--' },
  { cd: 'AIRPORT', descr: 'AIRPORT' },
  { cd: 'AVE', descr: 'AVE' },
  { cd: 'BLVD', descr: 'BLVD' },
  { cd: 'CIR', descr: 'CIR' },
  { cd: 'CIRCLE', descr: 'CIRCLE' },
  { cd: 'CT', descr: 'CT' },
  { cd: 'CRES', descr: 'CRES' },
  { cd: 'DR', descr: 'DR' },
  { cd: 'EXPY', descr: 'EXPY' },
  { cd: 'RAMP', descr: 'RAMP' },
  { cd: 'ER', descr: 'ER' },
  { cd: 'XR', descr: 'XR' },
  { cd: 'FLD', descr: 'FLD' },
  { cd: 'HWY', descr: 'HWY' },
  { cd: 'LN', descr: 'LN' },
  { cd: 'MKT', descr: 'MKT' },
  { cd: 'PKWY', descr: 'PKWY' },
  { cd: 'PL', descr: 'PL' },
  { cd: 'PLAISANCE', descr: 'PLAISANCE' },
  { cd: 'PLZ', descr: 'PLZ' },
  { cd: 'RL', descr: 'RL' },
  { cd: 'RD', descr: 'RD' },
  { cd: 'ROW', descr: 'ROW' },
  { cd: 'SR', descr: 'SR' },
  { cd: 'SKYWAY', descr: 'SKYWAY' },
  { cd: 'SQ', descr: 'SQ' },
  { cd: 'ST', descr: 'ST' },
  { cd: 'TER', descr: 'TER' },
  { cd: 'TOLL', descr: 'TOLL' },
  { cd: 'WAY', descr: 'WAY' },
];
